import { IApi } from '../../../api'
import { createRequestTypes } from '../../../helpers/helpers'
import { createAction } from '../../types'

export const prefix = 'atlasai/automations'

export const LIST_AUTOMATIONS = createRequestTypes(prefix, 'LIST_AUTOMATIONS')
export const [LIST_AUTOMATIONS_REQUEST, LIST_AUTOMATIONS_SUCCESS, LIST_AUTOMATIONS_FAILURE] =
  LIST_AUTOMATIONS

export const listAutomations = createAction((params?: object) => ({
  type: LIST_AUTOMATIONS,
  promise: (api: IApi) => api.atlasAI.listAutomations(params),
  params,
}))

export const GET_AUTOMATION = createRequestTypes(prefix, 'GET_AUTOMATION')
export const [GET_AUTOMATION_REQUEST, GET_AUTOMATION_SUCCESS, GET_AUTOMATION_FAILURE] =
  GET_AUTOMATION

export const getAutomation = createAction((id: string, params?: object) => ({
  type: GET_AUTOMATION,
  promise: (api: IApi) => api.atlasAI.getAutomation(id, params),
}))

export const CREATE_AUTOMATION = createRequestTypes(prefix, 'CREATE_AUTOMATION')
export const [CREATE_AUTOMATION_REQUEST, CREATE_AUTOMATION_SUCCESS, CREATE_AUTOMATION_FAILURE] =
  CREATE_AUTOMATION

export const createAutomation = createAction((data: object) => ({
  type: CREATE_AUTOMATION,
  promise: (api: IApi) => api.atlasAI.createAutomation(data),
}))

export const UPDATE_AUTOMATION = createRequestTypes(prefix, 'UPDATE_AUTOMATION')
export const [UPDATE_AUTOMATION_REQUEST, UPDATE_AUTOMATION_SUCCESS, UPDATE_AUTOMATION_FAILURE] =
  UPDATE_AUTOMATION

export const updateAutomation = createAction((id: string, data: object) => ({
  type: UPDATE_AUTOMATION,
  promise: (api: IApi) => api.atlasAI.updateAutomation(id, data),
}))

export const DELETE_AUTOMATION = createRequestTypes(prefix, 'DELETE_AUTOMATION')
export const [DELETE_AUTOMATION_REQUEST, DELETE_AUTOMATION_SUCCESS, DELETE_AUTOMATION_FAILURE] =
  DELETE_AUTOMATION

export const deleteAutomation = createAction((id: string) => ({
  type: DELETE_AUTOMATION,
  promise: (api: IApi) => api.atlasAI.deleteAutomation(id),
}))

export const CLEAR_SELECTED_AUTOMATION = `${prefix}/CLEAR_SELECTED_AUTOMATION`

export const clearSelectedAutomation = () => ({ type: CLEAR_SELECTED_AUTOMATION })
